var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveWip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83327 12.1226C5.32569 12.007 4.83813 11.8165 4.3866 11.5574M8.1666 1.88281C9.32636 2.14769 10.3618 2.79847 11.1035 3.7286C11.8451 4.65873 12.249 5.81311 12.249 7.00273C12.249 8.19235 11.8451 9.34673 11.1035 10.2769C10.3618 11.207 9.32636 11.8578 8.1666 12.1226M2.67102 9.97365C2.35315 9.51114 2.1115 9.00066 1.95527 8.46165M1.82227 6.12773C1.9156 5.57356 2.09527 5.04856 2.34727 4.56731L2.44585 4.3894M4.02902 2.67381C4.57513 2.29866 5.18732 2.03027 5.83327 1.88281",
    stroke: "#8B8B8B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveWip);
export default __webpack_public_path__ + "static/media/InActiveWIP.afe4235c7d66b966a79b25bb468c563d.svg";
export { ForwardRef as ReactComponent };